import script from "./MilkNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./MilkNotice.vue?vue&type=script&setup=true&lang=js"

import "./MilkNotice.vue?vue&type=style&index=0&id=42ffd47a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ffd47a"]])

export default __exports__